import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "submitBtn"];

  connect() {
    console.log("Import loading controller connected");
  }

  show(event) {
    console.log("Form submitted, showing overlay");

    // Mostra l'overlay di caricamento
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("d-none");
      this.overlayTarget.style.display = "flex";
      // Disabilita lo scroll della pagina
      document.body.style.overflow = "hidden";

      console.log("Overlay shown");
    } else {
      console.error("Overlay target not found!");
    }
  }

  hide() {
    // Nasconde l'overlay di caricamento
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("d-none");
      this.overlayTarget.style.display = "none";
      // Riabilita lo scroll della pagina
      document.body.style.overflow = "";
    }
  }

  disconnect() {
    // Cleanup quando il controller viene disconnesso
    // Assicurati che l'overlay sia nascosto e lo scroll sia riabilitato
    this.hide();
  }
}
